import { Box, Paper, Stack, Text, Title } from '@mantine/core';
import { useFlags } from 'src/feature-flags/FlagsHook';
import TenantApiKeysManager from './TenantApiKeysManager';

export default function DevToolsPage() {
  const { flagEnabledExternalApiKeys } = useFlags();

  return (
    <Box p="md">
      <Stack gap="lg">
        <Box>
          <Title order={3}>Dev tools</Title>
          <Text size="sm" c="dimmed">
            Developer tools for your organisation.
          </Text>
        </Box>

        {flagEnabledExternalApiKeys ? (
          <Paper withBorder radius="md" p="md">
            <Stack gap="md">
              <Text size="sm" c="dimmed">
                Manage external API keys for your organisation. Keys authenticate requests to the
                external API and are shown only once at the time of generation.
              </Text>
              <TenantApiKeysManager />
            </Stack>
          </Paper>
        ) : (
          <Text size="sm" c="dimmed">
            No dev tools are currently enabled.
          </Text>
        )}
      </Stack>
    </Box>
  );
}
